const {
  animation,
  animation: { easings, fadeIn, fadeOut, scrollTo, requestAnimFrame, transition, transitions }
} = window.o_util;

export { animation, easings, fadeIn, fadeOut, requestAnimFrame, scrollTo, transition, transitions };
/*                                  */
